import { PlatformInfo } from "@verity/api-client/types";

type VerityPlatform = Exclude<PlatformInfo["platform"], "none">;
export type BrowserType =
	| "desktop-browser"
	| "desktop-lockdown"
	| "mobile-browser"
	| "mobile-lockdown"
	| "chromeos-browser";

export const PLATFORM_COMPATIBLE_BROWSERS: Record<VerityPlatform, BrowserType[]> = {
	extension: ["desktop-browser", "chromeos-browser"],
	lockdown: ["desktop-browser", "desktop-lockdown"],
	mobile: ["mobile-browser", "mobile-lockdown"],
};

export function isMobileDevice() {
	const userAgent = navigator.userAgent || navigator.vendor;
	return (
		/android|avantgo|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(40|60)|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|iPad/i.test(
			userAgent,
		) ||
		(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
	);
}

export function isChromeOsDevice() {
	return navigator.userAgent.includes("CrOS");
}

export function getBrowserType(userPlatform: PlatformInfo["platform"] = "none"): BrowserType {
	if (userPlatform === "lockdown") {
		return "desktop-lockdown";
	} else if (userPlatform === "mobile") {
		return "mobile-lockdown";
	} else if (isMobileDevice()) {
		return "mobile-browser";
	} else if (isChromeOsDevice()) {
		return "chromeos-browser";
	}
	return "desktop-browser";
}

export function isPlatformCompatible(platform: VerityPlatform, browserType: BrowserType) {
	return PLATFORM_COMPATIBLE_BROWSERS[platform].includes(browserType);
}

export function getCompatiblePlatforms(browserType: BrowserType) {
	return Object.keys(PLATFORM_COMPATIBLE_BROWSERS).filter((platform) =>
		PLATFORM_COMPATIBLE_BROWSERS[platform as VerityPlatform].includes(browserType),
	) as VerityPlatform[];
}
